// @ts-check
import {
  GET_RATE_LIMITS_BY_USER
} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const getRateLimitStatus = state => state.status[getActionStatusName(GET_RATE_LIMITS_BY_USER)] || {};

export const getRateLimitFormattedData = state => {
  const limits = state.rateLimits.map(rateLimit => {
    return {
      rateLimitsName: rateLimit.name,
      rateLimitsEmail: rateLimit.email,
      rateLimitsRole: rateLimit.role,
    }
  });

  return limits;
};
